export interface AuthIdentityFence {
  userId: string | null;
  sessionToken: string | null;
  generation: number;
}

export function advanceAuthIdentityFence(
  previousGeneration: number,
  userId: string | null,
  sessionToken: string | null,
): AuthIdentityFence {
  return {
    userId,
    sessionToken,
    generation: previousGeneration + 1,
  };
}

export function canApplyStaffSsoPolicy(
  expected: AuthIdentityFence,
  current: AuthIdentityFence,
  signal?: AbortSignal,
): boolean {
  return !signal?.aborted &&
    expected.userId !== null &&
    expected.sessionToken !== null &&
    expected.userId === current.userId &&
    expected.sessionToken === current.sessionToken &&
    expected.generation === current.generation;
}
